// extracted by mini-css-extract-plugin
module.exports = {"footerActions":"styles_footerActions__yIDrb","footerDisclaimer":"styles_footerDisclaimer__XOTF9","footer":"styles_footer__n8auu"};